import 'dayjs/locale/pl'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.locale('pl')
dayjs.extend(relativeTime)
dayjs.extend(duration)

export default dayjs
